module.exports = __webpack_public_path__ + "img/ke.57168c2d.svg";